<template>
  <div class="dash">
    <div class="dash__tiles">
      <StatTile tone="danger" label="Kod advokata" :value="fmt(d.sud.broj)"
        :meta="fmt(d.sud.zastoj) + ' bez pomaka 30+ dana'" />
      <StatTile tone="warn" label="Sporazum u toku" :value="fmt(d.sporazum.broj)"
        :meta="fmt(d.sporazum.zastoj) + ' stoji duže od 30 d'" />
      <StatTile label="Prigovori" :value="fmt(d.prigovor.broj)"
        :meta="fmt(d.prigovor.zastoj) + ' bez odgovora 30+ d'" />
    </div>

    <div class="dash__body">
      <CaseList
        class="dash__main"
        title="Kod advokata — najduže bez pomaka"
        subtitle="otvoreni predmeti čiji je nosioc advokat, u bilo kojoj fazi"
        :rows="d.lista_sud"
        :footer="fmt(d.sud.broj) + ' sudskih predmeta · prikazano ' + d.lista_sud.length"
        empty-text="Nema sudskih predmeta"
      />

      <aside class="dash__rail">
        <section class="card">
          <h2 class="card__title">Sporazumi u toku</h2>
          <div class="card__hint">čeka potpis ili realizaciju</div>
          <div v-if="!d.lista_sporazum.length" class="card__hint">Nema sporazuma u toku</div>
          <div v-else class="ready">
            <div
              v-for="r in d.lista_sporazum"
              :key="r.id"
              class="ready__row"
              @click="$router.push('/predmet/view/' + r.id)"
            >
              <strong>{{ r.broj }}</strong>
              <span class="ready__name">{{ r.osteceni || "—" }}</span>
              <span class="ready__days" :class="{ 'is-stale': r.dana_bez_pomaka >= 30 }">
                {{ r.dana_bez_pomaka }} d
              </span>
            </div>
          </div>
        </section>

        <section class="card">
          <h2 class="card__title">Gdje stoji najviše</h2>
          <div class="card__hint">udio predmeta u zastoju po fazi</div>
          <div class="rows">
            <div class="row">
              <div>
                <div class="row__label">Kod advokata</div>
                <div class="row__bar"><span class="row__fill" style="background: #c25b6a" :style="{ width: pct(d.sud.zastoj, d.sud.broj) + '%' }"></span></div>
              </div>
              <span class="row__value">{{ pct(d.sud.zastoj, d.sud.broj) }}%</span>
            </div>
            <div class="row">
              <div>
                <div class="row__label">Sporazum</div>
                <div class="row__bar"><span class="row__fill" :style="{ width: pct(d.sporazum.zastoj, d.sporazum.broj) + '%', background: '#7c6fd0' }"></span></div>
              </div>
              <span class="row__value">{{ pct(d.sporazum.zastoj, d.sporazum.broj) }}%</span>
            </div>
            <div class="row">
              <div>
                <div class="row__label">Prigovor</div>
                <div class="row__bar"><span class="row__fill" :style="{ width: pct(d.prigovor.zastoj, d.prigovor.broj) + '%', background: '#d97742' }"></span></div>
              </div>
              <span class="row__value">{{ pct(d.prigovor.zastoj, d.prigovor.broj) }}%</span>
            </div>
          </div>
        </section>
      </aside>
    </div>
  </div>
</template>

<script>
import StatTile from "./StatTile";
import CaseList from "./CaseList";

export default {
  name: "LegalDash",
  components: { StatTile, CaseList },
  props: { data: { type: Object, required: true } },
  computed: {
    d() {
      return this.data;
    },
  },
  methods: {
    fmt(v) {
      return String(Math.round(Number(v) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    pct(a, b) {
      if (!b) return 0;
      return Math.round((a / b) * 100);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./dash.scss";

.row__label {
  font-size: var(--fs-sm);
  color: var(--ink);
  margin-bottom: 4px;
}

.ready {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 12px;
}

.ready__row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  background: var(--surface-alt);
  border-radius: var(--r-md);
  font-size: var(--fs-sm);
  cursor: pointer;

  &:hover {
    background: var(--brand-tint);
  }
}

.ready__name {
  flex-grow: 1;
  color: var(--ink-2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ready__days {
  color: var(--ink-4);
  font-variant-numeric: tabular-nums;

  &.is-stale {
    color: var(--danger);
    font-weight: 600;
  }
}
</style>
